import { ConcreteEncodable } from "./ConcreteEncodable";

import { FwdRollCurrencyNetPricingImplEncoder } from "../../encoder/FwdRollCurrencyNetPricingImplEncoder";

import * as CubiqTS from "../../index";
import { FwdRollCurrencyNetPricing } from "../FwdRollCurrencyNetPricing";

export class FwdRollCurrencyNetPricingImpl
  extends ConcreteEncodable
  implements FwdRollCurrencyNetPricing
{
  public static enType: string = "com.bcdfx.model.fwdroll.FwdRollCurrencyNetPricingImpl";

  /*FID=1*/
  public baseCcy: string;
  /*FID=2*/
  public nonBaseCcy: string;
  /*FID=3*/
  public fixedCcy: string;
  /*FID=4*/
  public netIntent: CubiqTS.OrderIntent;
  /*FID=5*/
  public spotAggregateFg: boolean;
  /*FID=6*/
  public settleTenor: CubiqTS.Tenor;
  /*FID=7*/
  public settleDate: CubiqTS.moment.Moment | null = null;
  /*FID=8*/
  public netFixedAmt: CubiqTS.BigNumber | null = null;
  /*FID=9*/
  public netUsdEquivAmt: CubiqTS.BigNumber | null = null;
  /*FID=10*/
  public marketSpotRate: CubiqTS.BigNumber | null = null;
  /*FID=11*/
  public marketForwardPts: CubiqTS.BigNumber | null = null;
  /*FID=12*/
  public marketForwardRate: CubiqTS.BigNumber | null = null;
  /*FID=13*/
  public clientSpotRate: CubiqTS.BigNumber | null = null;
  /*FID=14*/
  public clientForwardPts: CubiqTS.BigNumber | null = null;
  /*FID=15*/
  public clientForwardRate: CubiqTS.BigNumber | null = null;
  /*FID=16*/
  public spotMarkup: CubiqTS.BigNumber | null = null;
  /*FID=17*/
  public fwdMarkup: CubiqTS.BigNumber | null = null;
  /*FID=18*/
  public missingPoints: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=590*/
  public rowId: string;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FwdRollCurrencyNetPricingImplEncoder.Instance;
    this.setEncodableType(FwdRollCurrencyNetPricingImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "FwdRollCurrencyNetPricingImpl[" +
      "baseCcy=" +
      this.baseCcy +
      "nonBaseCcy=" +
      this.nonBaseCcy +
      "fixedCcy=" +
      this.fixedCcy +
      "netIntent=" +
      this.netIntent +
      "spotAggregateFg=" +
      this.spotAggregateFg +
      "settleTenor=" +
      this.settleTenor +
      "settleDate=" +
      this.settleDate +
      "netFixedAmt=" +
      this.netFixedAmt +
      "netUsdEquivAmt=" +
      this.netUsdEquivAmt +
      "marketSpotRate=" +
      this.marketSpotRate +
      "marketForwardPts=" +
      this.marketForwardPts +
      "marketForwardRate=" +
      this.marketForwardRate +
      "clientSpotRate=" +
      this.clientSpotRate +
      "clientForwardPts=" +
      this.clientForwardPts +
      "clientForwardRate=" +
      this.clientForwardRate +
      "spotMarkup=" +
      this.spotMarkup +
      "fwdMarkup=" +
      this.fwdMarkup +
      "missingPoints=" +
      this.missingPoints +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "rowId=" +
      this.rowId +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
